export default class VendaHistoricoFilterModel {
    Continuo: string;
    DataVenda?: Date = null;

    showFiltroAvancado = false;
}
